import { css } from '@emotion/css';
import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';
import { Dialog } from 'src/components/shared/dialog/Dialog';
import { RootState } from '../../../features';
import { actions } from '../../../features/bestFriends';
import { FadeRoute } from '../../shared/routes/FadeRoute';
import { FriendDetail } from './FriendDetail';
import { PageFriendDetailMenu } from './PageFriendDetailMenu';

const detailPagePath = '/players/best-friends/detail';

export const FriendDetailDialog: React.FC = () => {
  const routeMatch = useRouteMatch();
  const location = useLocation();
  const params = useParams<{ id?: string }>();
  const history = useHistory();
  const { t, i18n } = useTranslation('best_friends');
  const { friendItems, profiles, profileErrorType } = useSelector(
    (state: RootState) => state.bestFriends
  );
  const dispatch = useDispatch();
  const friendId = params.id;
  const friendItem = friendItems.find(item => item.id === params.id);
  const friendProfile = profiles.find(profile => profile.userId === params.id);
  const language = i18n.language;

  const handleMenuClick = useCallback(() => {
    if (routeMatch && friendItem) {
      history.replace(`${detailPagePath}/${friendItem.id}/menu/1`);
    }
  }, [routeMatch, history, friendItem]);

  useEffect(() => {
    if (friendId) {
      dispatch(actions.getFriendProfile({ id: friendId, language }));
    }
  }, [dispatch, friendId, language]);

  const hasMenu = routeMatch?.url === location.pathname;

  return (
    <Dialog
      hasHeader={true}
      hasMenu={hasMenu}
      onMenuClick={handleMenuClick}
      menuAriaLabel={t('aria_button_block_menu')}
    >
      <>
        <div
          className={css`
            position: relative;
          `}
        >
          {friendItem && (
            <FriendDetail
              friendItem={friendItem}
              comment={friendProfile?.mComment}
              profileErrorType={profileErrorType}
            />
          )}
          <FadeRoute path={`${detailPagePath}/:id/menu/:page`}>
            <PageFriendDetailMenu />
          </FadeRoute>
        </div>
      </>
    </Dialog>
  );
};
